import { gql } from '@apollo/client';

//TODO addeleve graphql routes
export const ADD_ELEVE = gql`
  mutation addUser(
    $lastname: String!
    $firstname: String
    $email: String
    $username: String
    $password: String
    $classes: [ID]
    $role: ID
  ) {
    createUsersPermissionsUser(
      data: {
        lastname: $lastname
        firstname: $firstname
        email: $email
        username: $username
        password: $password
        classes: $classes
        role: $role
      }
    ) {
      data {
        attributes {
          firstname
          lastname
          username
          mdp
          email
          classes {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;
